export const MEX_FLAG = "🇲🇽";
export const US_FLAG = "🇺🇸";
